import { CenterContentContainer, Container } from "src/components/auth/common/layout.styled";
import { H1Bold, Text1Bold, Text1Thin } from "src/components/common/layout/typography.styled";
import Icon from "src/components/common/Icon";
import { useLocation } from "react-router-dom";

export default function SignUpEmailVerification() {
  const location = useLocation();
  // get email from navigation state
  const email = location?.state?.email;
  return (
    <Container>
      <CenterContentContainer>
        <H1Bold>Check Your Email to Get Started!</H1Bold>
        {email && (
          <>
            <Text1Bold style={{ marginTop: "16px" }}>{` We've sent an activation link to ${email}`}</Text1Bold>
            <Text1Bold marginBottom={8}>Click the link in the email to activate your account.</Text1Bold>
            <Text1Thin>{`Can't find the email?`}</Text1Thin>
            <Text1Thin marginBottom={18}>Check your spam folder or request a new one.</Text1Thin>
            <Text1Thin>* This will take less than a minute</Text1Thin>
          </>
        )}
        <Icon.Mail size={165} color="pink.500" />
      </CenterContentContainer>
    </Container>
  );
}
